import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    maybeUpdateRoomStatus,
    updateFinalRoomAnswer,
    getFinalRoomAnswers,
    setMiddleState,
    updateRoomAnswer,
    getRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomCluesEquations extends BD_Component {
    constructor() {
        super();

        this.id = "clues_equations";
        this.templateID = "clues_equations-template";

        this.elms = {
            equationItem: ".js-equation-item",
            questionItem: ".js-question-item",
            closeBtn: ".js-cluesEquations-close",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-check-button",
            background: ".js-screen-img",
        };

        this._events = this.getEvents();

        this.userAnswer = undefined;

        this.completionPopup = new CompletionPopup();

        this.currentMousePos = { x: 0, y: 0 };
        this.originMousePos = { x: 0, y: 0 };
        this.zoom = 100;
        this.isDown = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.equationItem,
                handler: this.openEquationItem,
            },
            {
                event: "click",
                selector: elms.closeBtn,
                handler: this.closeEquationItem,
            },
            {
                event: "blur",
                selector: elms.inputAnswer,
                handler: this.onBlurInput,
            },
            {
                event: "focus",
                selector: elms.inputAnswer,
                handler: this.onInputFocus,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
            {
                event: "mousedown",
                selector: elms.background,
                handler: this.onBackgroundPress,
            },
            {
                event: "mousemove",
                selector: elms.background,
                handler: this.onBackgroundMove,
            },
            {
                event: "mouseup",
                selector: elms.background,
                handler: this.onBackgroundnotMove,
            },
            {
                event: "wheel",
                selector: elms.background,
                handler: this.onBackgroundScroll,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
    }

    getModifiedData() {
        const modifiedData = { ...this._data };
        const hotspots = modifiedData["hotspots"];

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-clues-equations.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const _questions = this._data.questions.map((q, i) => {
            if (hotspots.length < 1) return q;

            if (hotspots[i]["hotspot_type"] === "puzzle") {
                let hotspot = { ...hotspots[i] };
                return {
                    ...q,
                    position_top: hotspot["position_top"],
                    position_left: hotspot["position_left"],
                };
            }
        });

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const modified = {
            ...modifiedData,
            questions: _questions,
            hints: _hints,
            image_bg: _image_bg,
        };

        return modified;
    }

    render() {
        const data = this.getModifiedData();
        const isForcedOpenChallenge = data["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);

        if (isForcedOpenChallenge) {
            // this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {}

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);

        /**
         * @type {BD_RoomCluesEquationsFinalAnswer}
         */
        const teamAnswers = getFinalTeamAnswers(roomId);

        const roomAnswers = getRoomAnswerById(roomId);
        const self = this;
        const elms = self.elms;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (teamAnswers) {
            let isMiddleState = false;
            $.each(teamAnswers, function (questionID, item) {
                const answer = item.answer;
                const isMiddle = answer === roomAnswers[questionID]?.middle;
                const $wrapper = $(
                    elms.questionItem + `[data-id="${questionID}"]`,
                );
                const $equationItem = $(
                    elms.equationItem + `[data-id="${questionID}"]`,
                );

                [...answer].forEach(function (value, index) {
                    $wrapper
                        .find(elms.inputAnswer)
                        .eq(index)
                        .prop("readonly", true)
                        .val(value);
                    $wrapper
                        .find(elms.inputAnswer)
                        .eq(index)
                        .next()
                        .text(value);
                });

                isMiddleState =
                    isMiddle && !isMiddleState ? true : isMiddleState;

                $wrapper.removeClass("is-wrong").addClass("is-completed");
                if (isMiddle) $wrapper.addClass("is-middle");
                $equationItem.addClass("is-completed");
            });

            if (thisRoomStatus == "is-status-completed") {
                $(".app__page").addClass("is-room-completed");

                /* Show completion popup */
                this.completionPopup.show(roomId, isMiddleState, roomAnswers);
            }
        }

        getRoomAnswers(roomId).then((data) => {
            this.updateUserChoicesList(data);
        });
    }

    // ============================== CUSTOM FUNCTION
    onBackgroundPress(e) {
        this.originMousePos.x = e.clientX;
        this.originMousePos.y = e.clientY;
        this.isDown = true;
    }

    onBackgroundMove(e) {
        const background = $(this.elms.background);
        const bounds = {
            w: background.width() - $(window).width() * 1.1,
            h: background.height() - $(window).height() * 1.1,
        };
        let inbounds = { x: false, y: false },
            offset = {
                x: this.currentMousePos.x - (this.originMousePos.x - e.clientX),
                y: this.currentMousePos.y - (this.originMousePos.y - e.clientY),
            };
        inbounds.x = offset.x < 0 && offset.x * -1 < bounds.w;
        inbounds.y = offset.y < 0 && offset.y * -1 < bounds.h;

        if (this.isDown && inbounds.x && inbounds.y) {
            this.currentMousePos.x = offset.x;
            this.currentMousePos.y = offset.y;

            background.css({
                top: `calc(50% + ${this.currentMousePos.y}px)`,
                left: `calc(50% + ${this.currentMousePos.x}px)`,
            });
            $(".screen__navigate").css({
                top: `calc(50% + ${this.currentMousePos.y}px)`,
                left: `calc(50% + ${this.currentMousePos.x}px)`,
            });
        }

        this.originMousePos.x = e.clientX;
        this.originMousePos.y = e.clientY;
    }

    onBackgroundnotMove() {
        this.isDown = false;
    }

    onBackgroundScroll(e) {
        let delta = e.originalEvent.deltaY < 0 ? "up" : "down";
        if (delta === "up" && this.zoom < 120) {
            this.zoom += 2;
        } else if (delta === "down" && this.zoom > 100) {
            this.zoom -= 2;
        }
        $(".screen__navigate").css({
            cssText: `width: ${this.zoom}% !important; height: ${this.zoom}% !important`,
        });
        $(this.elms.background).css({
            cssText: `width: ${this.zoom}% !important; height: ${this.zoom}% !important`,
        });
    }

    openEquationItem(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const dataID = $el.attr("data-id");

        $(elms.questionItem + `[data-id="${dataID}"]`).addClass("is-open");
        $(".app-blur").addClass("is-blurred");
        $(".timer").addClass("is-clues-equation");
    }

    closeEquationItem(e, el) {
        const elms = this.elms;
        const $el = $(el);

        $el.parents(elms.questionItem).removeClass("is-open");
        $(".app-blur").removeClass("is-blurred");
        $(".timer").removeClass("is-clues-equation");
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const elms = this.elms;
        const $questionWrapper = $el.parents(elms.questionItem);

        if ($questionWrapper.hasClass("is-completed")) {
            return false;
        }

        $questionWrapper.removeClass("is-wrong");

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);

        if (!regex.test(key)) {
            this.toggleCheckButton($el);
            return false;
        }

        const value = String($el.val(e.key));

        const $current = $el.parents(".inputTyping__item");
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $el.trigger("blur");
            $nextInput.find("input").trigger("focus");
        }

        this.toggleCheckButton($el);
    }

    toggleCheckButton($el) {
        const elms = this.elms;
        const $questionWrapper = $el.parents(".js-question-wrapper");
        const $checkBtn = $questionWrapper.find(elms.checkAnswer);
        const $answers = $questionWrapper.find(elms.inputAnswer);
        let isAllAnswered = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());
            if (answer.trim() == "") {
                isAllAnswered = false;
                return false;
            }
        });

        return $checkBtn
            .prop("disabled", !isAllAnswered)
            .toggleClass("valid", isAllAnswered);
    }

    checkAnswer(e, el) {
        const $el = $(el);
        const elms = this.elms;

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionWrapper = $el.parents(elms.questionItem).first();
        const questionId = $questionWrapper.attr("data-id");
        const $equationItem = $(
            elms.equationItem.concat(`[data-id="${questionId}"]`),
        );
        const $answers = $questionWrapper.find(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionWrapper.removeClass("is-wrong is-completed is-middle");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);

        let roomStatus = "is-status-started";
        let isMiddleState = false;
        let isCorrect = false;
        let playerAnswer = "";
        const isUsingMiddleState = this._data.isUseMiddleState;

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            playerAnswer += $answer.val();
        });

        const correctAnswer = roomAnswers?.[questionId]?.correct || false;
        const middleAnswer = roomAnswers?.[questionId]?.middle || false;

        playerAnswer = playerAnswer.toLowerCase();

        if (playerAnswer === correctAnswer) {
            isCorrect = true;
        } else if (isUsingMiddleState && playerAnswer === middleAnswer) {
            isCorrect = true;
            isMiddleState = true;
        }

        const updateData = {
            [questionId]: {
                answer: playerAnswer,
                isMiddleState: isMiddleState,
            },
        };

        if (isCorrect) {
            $questionWrapper.removeClass("is-wrong").addClass("is-completed");
            if (isMiddleState) $questionWrapper.addClass("is-middle");

            $answers.prop("readonly", true);

            $el.removeClass("is-loading valid");
            $equationItem.addClass("is-completed");

            maybeUpdateRoomStatus(roomId, roomStatus);

            const onSuccessUpdate = () => {
                if (isMiddleState) {
                    $questionWrapper.addClass("is-middle");
                    setMiddleState(roomId);
                }

                $questionWrapper.removeClass("is-wrong");
                $questionWrapper.addClass("is-completed");
                $equationItem.addClass("is-completed");
                $answers.prop("readonly", true);

                this.maybeRoomIsFinish.call(this);
            };

            const onErrorUpdate = () => {};

            updateFinalRoomAnswer(roomId, updateData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);

            $el.removeClass("is-loading valid");
        } else {
            $questionWrapper.addClass("is-wrong");
            $el.removeClass("is-loading").removeAttr("disabled");

            maybeUpdateRoomStatus(roomId, roomStatus);
        }

        this.userAnswer = {
            [questionId]: {
                ...updateData[questionId],
                isCorrect: isCorrect,
            },
        };

        this.updateUserAnswer();
    }

    maybeRoomIsFinish() {
        const roomId = this.roomId;
        getFinalRoomAnswers(roomId).then((data) => {
            const roomAnswers = getRoomAnswerById(roomId);
            const fbRoomAnswers = data.val();

            if (
                !fbRoomAnswers ||
                typeof roomAnswers !== "object" ||
                typeof fbRoomAnswers !== "object"
            ) {
                return;
            }

            if (
                Object.keys(roomAnswers).length ==
                Object.keys(fbRoomAnswers).length
            ) {
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            }
        });
    }

    onBlurInput(e) {
        let $this = $(e.currentTarget);
        let val = String($this.val());
        let display = $this.next();

        display.removeClass("on-input");
        display.text(val.trim());
    }

    onInputFocus(e) {
        const $this = $(e.currentTarget);
        const display = $this.next();
        const val = String($this.val());

        display.addClass("on-input");

        if (val.trim() === "") {
            display.text("");
        }

        if (val.trim().length) {
            $this[0].setSelectionRange(val.length - 1, val.length);
        }
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID]) {
                    const answer = thisPlayerAnswer[questionID].answer;
                    const user = {
                        ...player,
                        answer: answer,
                    };

                    return user;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
